import React from 'react';
import HamburgerIcon from './hamburger';
import ArrowLeftIcon from './icon-arrow-left';
import ArrowRightIcon from './icon-arrow-right';
import PodcastIcon from './icon-podcast';
import PointRightIcon from './icon-point-right';
import CloseCirectIcon from './icon-x-circle';
import Tick from './tick';
import Share from './share';
import Fullscreen from './fullscreen';
import PageFold from './page-fold';
import GritLockup from './grit-lockup';
import Spotify from './spotify';
import Apple from './apple';
import MakeHistory from './make-history';
import DotsSquare from './dots-square';
import KP from './kleiner-perkins';
import KPMark from './kp-mark';
import EmailSocial from './email-social';
import TwitterSocial from './twitter-social';
import LinkedinSocial from './linkedin-social';
import ArrowThinBlue from './arrow-thinblue';
import QuoteMarksIcon from './quotation-marks';

function Icon(props) {
  switch (props.symbol) {
  case 'hamburger':
    return <HamburgerIcon />;
  case 'arrow-left':
    return <ArrowLeftIcon />;
  case 'arrow-right':
    return <ArrowRightIcon />;
  case 'podcast':
    return <PodcastIcon />;
  case 'point-right':
    return <PointRightIcon />;
  case 'close-circle':
    return <CloseCirectIcon />;
  case 'tick':
    return <Tick />;
  case 'share':
    return <Share />;
  case 'fullscreen':
    return <Fullscreen />;
  case 'page-fold':
    return <PageFold />;
  case 'grit-lockup':
    return <GritLockup />;
  case 'spotify':
    return <Spotify />;
  case 'apple':
    return <Apple />;
  case 'make-history':
    return <MakeHistory />;
  case 'dots-square':
    return <DotsSquare />;
  case 'kp':
    return <KP />;
  case 'kp-mark':
    return <KPMark />;
  case 'email-social':
    return <EmailSocial />;
  case 'twitter-social':
    return <TwitterSocial />;
  case 'linkedin-social':
    return <LinkedinSocial />;
  case 'arrow-thinblue':
    return <ArrowThinBlue />;
  case 'quotation-marks':
    return <QuoteMarksIcon />;
  default:
    return <span>Unknown icon: {props.symbol}</span>;
  }
}

export default Icon;
